<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 14:16:11
-->
<template>
  <div class="flex p10 bg-white">
    <div class="w70 f13 f-grey pt10">{{ name || label }}</div>
    <div class="flex-1">
      <FaImageUpload
        v-model="mValue"
        v-bind="mOptions"
        :maxCount="1"
      />
    </div>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

export default {
  name: "SchemaUpload",

  mixins: [schemaMixin],
  
  props: {
    name: {
      type: String,
      default: ''
    }
  }
};
</script>
